import styles from "./page-loading-indicator.module.css";
import { ThreeDot } from "react-loading-indicators";

export const PageLoadingIndicator = () => {
  return (
    <div className={styles.loadingContainer}>
      <ThreeDot color="lightGray" size="medium" text="" textColor="" />
    </div>
  );
};
